import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input } from 'reactstrap';
import { CheckCircle, XCircle } from 'react-feather';
import PropTypes from 'prop-types';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const ExpertReviewModal = ({ isOpen, toggle, onConfirm }) => {
    const initialFormData = {
        needExpertReview: true,
    };

    const {
        formData,
        setFormData,
        handleCancel,
    } = useModalCrudState({
        isOpen,
        mode: 'add',
        selectedItem: null,
        initialData: initialFormData,
        toggle,
    });

    const handleConfirm = () => {
        onConfirm(formData.needExpertReview);
        handleCancel();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} centered>
            <ModalHeader toggle={handleCancel}>
                Eksper Onayı Gereklilik Durumu
            </ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <p className="text-muted">
                        Düzeltme işlemi sonrasında bu çağrı formu eksper onayından geçecek mi?
                    </p>
                </div>
                
                <FormGroup>
                    <div className="d-flex flex-column gap-3">
                        <div 
                            className={`border rounded p-3 cursor-pointer ${formData.needExpertReview ? 'border-success bg-success bg-opacity-10' : 'border-secondary'}`}
                            onClick={() => setFormData(prev => ({ ...prev, needExpertReview: true }))}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="d-flex align-items-center">
                                <Input
                                    type="radio"
                                    name="expertReview"
                                    checked={formData.needExpertReview === true}
                                    onChange={() => setFormData(prev => ({ ...prev, needExpertReview: true }))}
                                    className="me-2"
                                />
                                <CheckCircle size={18} className="me-2 text-success" />
                                <div>
                                    <strong>Evet, eksper onayından geçecek</strong>
                                    <div className="text-muted small">
                                        Düzeltme sonrası form tekrar eksper onayına gönderilecek
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div 
                            className={`border rounded p-3 cursor-pointer ${formData.needExpertReview === false ? 'border-warning bg-warning bg-opacity-10' : 'border-secondary'}`}
                            onClick={() => setFormData(prev => ({ ...prev, needExpertReview: false }))}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="d-flex align-items-center">
                                <Input
                                    type="radio"
                                    name="expertReview"
                                    checked={formData.needExpertReview === false}
                                    onChange={() => setFormData(prev => ({ ...prev, needExpertReview: false }))}
                                    className="me-2"
                                />
                                <XCircle size={18} className="me-2 text-warning" />
                                <div>
                                    <strong>Hayır, eksper onayına gitmeyecek</strong>
                                    <div className="text-muted small">
                                        Düzeltme sonrası form doğrudan bir sonraki aşamaya geçecek
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleCancel}>
                    İptal
                </Button>
                <Button color="primary" onClick={handleConfirm}>
                    Onayla ve Devam Et
                </Button>
            </ModalFooter>
        </Modal>
    );
};

ExpertReviewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ExpertReviewModal;

